export default __webpack_public_path__ + "static/media/discord.3372aeeb.svg";